export default "__VITE_ASSET___o$GwZSd__"